import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import * as XLSX from 'xlsx';

import { useFormik } from "formik"
import * as Yup from "yup"
import "./siteUrl.css"
import {
  Card,
  CardBody,
  CardDeck,
  CardTitle,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Form,
  FormGroup,
  Input,
  Label,
  Button,
} from "reactstrap"

import Dropzone from "react-dropzone"

import { connect } from "react-redux"

import { setBreadcrumbItems } from "../../store/actions"
import { scrollToView, showToaster } from "components/Common/common";
import { useSelector } from "react-redux";
import { PAGECODE, PAGEPATHS, SIDEBARDATA } from "components/Common/Constant";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";

const BulkUrlsDisplay = ({ bulkUrls, getHeading, startScanningUrl }) => {
  if (!bulkUrls || Object.keys(bulkUrls).length === 0) return null;




  return (
    <>
      {Object.entries(bulkUrls).map(([key, urls], index) => (
        <Card className="mb-4" id="url-environment" key={index}>
          <CardBody>
            <h5 className="text-center">{getHeading(key)}</h5>
            <div className="urls d-flex flex-column align-items-center">
              {urls.map((n, i) => (
                <Button
                  className={`mb-1 custom-${key}`}
                  style={{
                    backgroundColor: key === 'prod' ? '#69c369' : key === 'dev' ? '#9c9ce9' : key === 'qa' ? '#e4a26e' : '#e076dd',
                    border: `1px solid ${key === 'prod' ? '#69c369' : key === 'dev' ? '#9c9ce9' : key === 'qa' ? '#e4a26e' : '#e076dd'}`,
                  }}
                  onClick={() => startScanningUrl(n)}
                  key={i}
                >
                  {/* {n.Name} */}
                </Button>
              ))}
            </div>
          </CardBody>
        </Card >
      ))}
    </>
  );
};


// const AddSiteUrl = props => {
//   document.title = "Add Site URL's"
const StartAScan = props => {

  document.title = "Start A Scan"

  const breadcrumbItems = [
    { title: "GovCompliance", link: "#" },
    // { title: "AddSiteURL", link: "#" },
    { title: "StartAScan", link: "#" },
  ]
  const [bulkUrls, setBulkUrls] = useState({})
  const user = useSelector((state) => state?.users?.users);
  // const hasWritePermission17 = user?.permissions?.write?.includes(PAGECODE["Add Site URL"]);
  const hasWritePermission17 = user?.permissions?.write?.includes(PAGECODE["Start A Scan"]);

  const valSchema = Yup.object().shape({
    //Name: Yup.string().required("Name is required"),
    ["Url Address"]: Yup.string()
      .required("Url Address is required"),
    ["Parent Website"]: Yup.string()
      .required("Parent Website is required"),
    Environment: Yup.string()
      .oneOf(["dev", "qa", "uat", "prod"], "Environment must be either prod, dev, qa or uat")
      .required("Environment is required"),
  });

  const urlSchema = Yup.array().of(valSchema);

  const handleDoc = async (file) => {
    if (file) {
      const reader = new FileReader()

      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
        const json = XLSX.utils.sheet_to_json(worksheet)
        try {
          await urlSchema.validate(json, { abortEarly: false })
        } catch (err) {
          console.log(err.errors);
          showToaster(0, err.errors[0])
          setBulkUrls({})
          return
        }
        let obj = {}
        for (let i = 0; i < json.length; i++) {
          const {
            Environment,
            //Name,
            ["Url Address"]: urlAddress,
            ["Parent Website"]: parentWebsite
          } = json[i]
          obj[Environment]
            ? obj[Environment].push({/*Name, */ urlAddress, parentWebsite })
            : obj[Environment] = [{/*Name, */ urlAddress, parentWebsite }]
        }
        setBulkUrls(obj)
        scrollToView('url-environment')
      }

      reader.readAsArrayBuffer(file)
    }
  }

  const getHeading = (type) => {
    const obj = {
      prod: "Production",
      dev: "Development",
      qa: "Q/A Test",
      uat: "User Acceptance Testing"
    }
    return obj[type]
  }

  // const startScanningUrl = (data) => {
  const checkURLValidity = (data) => {
    if (!data.urlAddress.match(/^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/)) {
      showToaster(0, `Invalid URL address: ${data.urlAddress}`)
      // return
      return 0
    }
    if (!data.parentWebsite.match(/^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/)) {
      showToaster(0, `Invalid parent web URL: ${data.parentWebsite}`)
      // return
      return 0
    }
    return 1
    // showToaster(1, 'Scanned Successfully!')
  }
  const startScanningUrl = (data) => {
    if (!checkURLValidity(data)) return;
    startScanAsynchronously(data.urlAddress);
    // showToaster(1, 'Scanned Successfully!')
  }

  const startScanAsynchronously = async (url) => {
    try {
      const response = await axiosInstance.post(ApiNames.START_SCAN + "?url=" + encodeURIComponent(url));
      // console.log("Scan response:", response.data);
      if (response.status === 200) {
        showToaster(1, "Scan started successfully!")
      } else {
        showToaster(0, "Failed to start scan.")
      }
    } catch (error) {
      console.error("Error starting scan:", error);
      showToaster(0, "An error occurred while starting the scan.\n" + error?.response?.data?.error)
    }
  }

  const startBulkScanAsynchronously = async (workbook) => {
    try {
      const response = await axiosInstance.post(ApiNames.START_BULK_SCAN, workbook);
      console.log("Bulk scan response:", response.data);
      if (response.status === 200) {
        showToaster(1, "Bulk scan started successfully!")
      } else {
        showToaster(0, "Failed to start bulk scan.")
      }
    } catch (error) {
      console.error("Error starting bulk scan:", error);
      showToaster(0, "An error occurred while starting the bulk scan.\n" + error?.response?.data?.error)
    }
  }

  const startScanningBulkUrls = () => {
    if (bulkUrls == {} || Object.keys(bulkUrls).length === 0) {
      showToaster(0, "No URLs to scan. Please upload a valid file.")
      return;
    }
    const workbook = generateBulkUrlsData();
    console.log("Workbook: ", workbook);
    if (workbook === -1) return;
    startBulkScanAsynchronously(workbook);
  }

  const generateBulkUrlsData = () => {
    console.log("Bulk URLs: ", bulkUrls);
    const arrayOfURLs = [].concat(bulkUrls['prod'] ?? [], bulkUrls['dev'] ?? [], bulkUrls['qa'] ?? [], bulkUrls['uat'] ?? []);
    console.log("JSON Data: ", arrayOfURLs);
    let invalidURLExists = false;
    arrayOfURLs.forEach((item) => {
      if (!checkURLValidity(item)) invalidURLExists = true;
    });
    if (invalidURLExists) return -1; // If any URL is invalid, return -1 to indicate failure
    return arrayOfURLs;
  }

  const [selectedFiles, setselectedFiles] = useState([])
  const [state, setState] = useState({
    activeTab: "1",
    activeTab1: "5",
    activeTab2: "9",
    activeTab3: "13",
    verticalActiveTab: "1",
    customActiveTab: "1",
    activeTabJustify: "5",
  })
  useEffect(() => {
    // props.setBreadcrumbItems("URL Management", [])
    props.setBreadcrumbItems("Start a Scan", [])
  })

  const toggle1 = tab => {
    if (state.activeTab1 !== tab) {
      setState({
        activeTab1: tab,
      })
    }
  }

  const handleAcceptedFiles = files => {
    handleDoc(files[0])
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    )
    setselectedFiles(files)
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const validationSchema = Yup.object({
    // URLaddress1: Yup.string().required("URLaddress1 is required"),
    // URLaddress2: Yup.string().required("URLaddress2 is required"),
    URLaddress1: Yup.string().required("URL address is required"),
    parentWebsite: Yup.string().required("parentWebsite is required"),
    environment: Yup.string()
      .oneOf(["dev", "qa", "uat", "prod"], "Environment must be either prod, dev, qa or uat")
      .required("Environment is required"),
  })

  const validation = useFormik({
    initialValues: {
      URLaddress1: "",
      // URLaddress2: "",
      parentWebsite: "",
      environment: "",
    },
    validationSchema,
    onSubmit: async values => {
      const { environment, ...other } = values
      const bulkData = {
        [environment]: [{
          //  Name: other.URLaddress1,
          urlAddress: other.URLaddress1,
          parentWebsite: other.parentWebsite
        }]
      }
      setBulkUrls(bulkData)
      scrollToView('url-environment')
      startScanningUrl(bulkData[environment][0])
    },
  })

  return (
    <React.Fragment>
      <Row className="justify-center">
        <Col lg={12}>
          <Card>
            <CardBody>
              <CardTitle className="h4 mb-4 mb-md-0">Start a Scan</CardTitle>

              <Nav pills className="navtab-bg nav-justified w-3/4 md:w-2/4 mx-auto">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer", paddingBlock: '0.7rem', fontSize: '0.9rem' }}
                    className={state.activeTab1 === "5" ? 'active_tab' : 'noactive_tab'}
                    onClick={() => {
                      toggle1("5")
                    }}
                  >
                    Single
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer", paddingBlock: '0.7rem', fontSize: '0.9rem' }}
                    className={state.activeTab1 === "6" ? 'active_tab' : 'noactive_tab'}
                    onClick={() => {
                      toggle1("6")
                    }}
                  >
                    Bulk
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                activeTab={state.activeTab1}
                className="p-3 text-muted"
              >
                <TabPane tabId="6">
                  <Row>
                    <Col className="col-md-8 mx-auto px-0">
                      <Card>
                        <CardBody>
                          <Form>
                            <Dropzone
                              onDrop={acceptedFiles => {
                                handleAcceptedFiles(acceptedFiles)
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div className="dropzone dz-clickable px-3 md:px-7">
                                  <div
                                    className="dz-message needsclick"
                                    {...getRootProps()}
                                  >
                                    <input {...getInputProps()} />
                                    <div className="mb-3">
                                      <i className="mdi mdi-cloud-upload-outline text-muted display-4"></i>
                                    </div>
                                    <h4 className="opacity-50 text-[14px] md:text-[20px]">
                                      Drop files here or click to upload.
                                    </h4>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                            <div
                              className="dropzone-previews mt-3"
                              id="file-previews"
                            >
                              {selectedFiles.map((f, i) => {
                                return (
                                  <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                  >
                                    <div className="p-2">
                                      <Row className="align-items-center">
                                        <Col className="col-auto">
                                          <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                          />
                                        </Col>
                                        <Col>
                                          <Link
                                            to="#"
                                            className="text-muted font-weight-bold"
                                          >
                                            {f.name}
                                          </Link>
                                          <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                          </p>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Card>
                                )
                              })}
                            </div>
                          </Form>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  {/*hasWritePermission17 &&*/

                    <Row>
                      <Col xl={12}>
                        <div className="d-flex justify-content-center text-white">
                          <Button
                            style={{ paddingBlock: '0.5rem', paddingInline: '1rem', width: 'fit-content' }}
                            type="button"
                            className="btn-primary fs-5"
                            onClick={startScanningBulkUrls}
                          >
                            {/* <i className="mdi mdi-content-save"></i> {"Save URLs"} */}
                            <i className="mdi mdi-content-save"></i> {"Scan URLs"}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  }
                </TabPane>
                <TabPane tabId="5">
                  <Row>
                    <Col sm="12">
                      <Form onSubmit={validation.handleSubmit}>
                        <FormGroup className="w-full md:w-1/2 mx-auto d-flex flex-column gap-2">
                          <Label>
                          </Label>
                          <Input
                            type="text"
                            name="URLaddress1"
                            value={validation.values.URLaddress1}
                            placeholder="Enter URL address"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            className="form-control form-control-lg custom-placeholder"
                          />
                          {validation.touched.URLaddress1 &&
                            validation.errors.URLaddress1 && (
                              <div className="text-danger text-start">
                                {validation.errors.URLaddress1}
                              </div>
                            )}
                        </FormGroup>

                        {/* <FormGroup className="w-full md:w-1/2 mx-auto d-flex flex-column gap-2">
                          <Label>
                          </Label>
                          <Input
                            type="text"
                            name="URLaddress2"
                            value={validation.values.URLaddress2}
                            placeholder="Enter URL address 2"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            className="form-control form-control-lg custom-placeholder"
                          />
                          {validation.touched.URLaddress2 &&
                            validation.errors.URLaddress2 && (
                              <div className="text-danger">
                                {validation.errors.URLaddress2}
                              </div>
                            )}
                        </FormGroup> */}

                        <FormGroup className="w-full md:w-1/2 mx-auto d-flex flex-column gap-2">
                          <Label>
                          </Label>
                          <Input
                            type="text"
                            name="parentWebsite"
                            value={validation.values.parentWebsite}
                            placeholder="Enter Parent website"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            className="form-control form-control-lg custom-placeholder"
                          />
                          {validation.touched.parentWebsite &&
                            validation.errors.parentWebsite && (
                              <div className="text-danger">
                                {validation.errors.parentWebsite}
                              </div>
                            )}
                        </FormGroup>

                        <FormGroup className="w-full md:w-1/2 mx-auto d-flex flex-column gap-2">
                          <Label>
                          </Label>
                          <Input
                            type="text"
                            name="environment"
                            value={validation.values.environment}
                            placeholder="Enter an environment"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            className="form-control form-control-lg custom-placeholder"
                          />
                          {validation.touched.environment &&
                            validation.errors.environment && (
                              <div className="text-danger">
                                {validation.errors.environment}
                              </div>
                            )}
                        </FormGroup>
                        {/*hasWritePermission17 &&*/
                          <FormGroup>
                            <div className="justify-content-center d-flex">
                              <Button
                                style={{ paddingBlock: '0.5rem', paddingInline: '1rem', width: 'auto' }}
                                type="submit"
                                className="btn-primary fs-5"
                              >
                                {/* <i className="mdi mdi-plus fw-bold font-size-17"></i> {"Add"} */}
                                <i className="mdi mdi-play fw-bold font-size-17"></i> {"Scan"}
                              </Button>
                            </div>
                          </FormGroup>

                        }

                      </Form>
                    </Col>
                  </Row>

                </TabPane>
              </TabContent>
              <Row>
                <Col className="col-12">
                  <CardDeck className="card-deck-wrapper">
                    <div className="card-group gap-3">
                      {/* <BulkUrlsDisplay
                        bulkUrls={bulkUrls}
                        getHeading={getHeading}
                        startScanningUrl={startScanningUrl}
                      /> */}
                    </div>
                  </CardDeck>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

// export default connect(null, { setBreadcrumbItems })(AddSiteUrl)
export default connect(null, { setBreadcrumbItems })(StartAScan)
